import { Fragment, useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import ClipLoader from "react-spinners/ClipLoader";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { config_url } from "../../config";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";

import Swal from "sweetalert2";
import {
  RiAddCircleFill,
  RiDeleteBin6Fill,
  RiEdit2Line,
  RiEyeOffLine,
  RiCheckDoubleFill,
  RiCloseLargeFill,
} from "react-icons/ri";
import { Tooltip, Typography } from "@mui/material";
import SelectOpt from "react-select";
import AffectedImageToJob from "./AffectedImageToJob";
import UpdImageJob from "./UpdImageJob";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
function ListJobs() {
  const [jobs, setJobs] = useState([]);

  const [open, setOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenImage, setIsModalOpenImage] = useState(false);
  const [rowCategory, setRowCategory] = useState({});

  const [image, setImage] = useState("");

  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  console.log(rowSelectionModel);

  useEffect(() => {
    const requestOptions = {
      method: "GET",
    };

    fetch(`${config_url}/api/jobs`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setJobs(result.results);
      })
      .catch((error) => console.error(error));
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleLoadModalImage = async (image) => {
    await handleOpen();

    await setImage(image);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModal = (row) => {
    setIsModalOpen(true);
    setRowCategory(row);
  };
  const closeModalUpdImage = () => {
    setIsModalOpen(false);
  };

  const openModalUpdImage = (row) => {
    setIsModalOpen(true);
    setRowCategory(row);
  };
  const columns = [
    {
      field: "title",
      headerName: "Job:",
      headerClassName: "super-app-theme--cell",

      width: 320,
      renderCell: (params) => {
        return (
          <div
            style={{
              marginTop: "4px",
              whiteSpace: "pre-line",
              overflow: "hidden",
            }}
          >
            <Typography>{params.row.title}</Typography>
          </div>
        );
      },
    },

    {
      field: "address",
      headerName: "Address:",
      headerClassName: "super-app-theme--cell",

      width: 160,
    },
    {
      field: "job_type",
      headerName: "Status:",
      headerClassName: "super-app-theme--cell",

      width: 180,
      renderCell: (params) => {
        return (
          <div
            style={{
              marginTop: "4px",
              whiteSpace: "pre-line",
              overflow: "hidden",
            }}
          >
            <Typography>{params.row.job_type.name}</Typography>
          </div>
        );
      },
    },
    {
      field: "bonus",
      headerName: "Bonus:",
      headerClassName: "super-app-theme--cell",

      width: 80,
    },
    {
      field: "salary",
      headerName: "Salary",
      headerClassName: "super-app-theme--cell",

      width: 140,
    },
    {
      field: "published_at",
      headerName: "Date Published",
      headerClassName: "super-app-theme--cell",

      width: 140,
    },
    {
      field: "created_at",
      headerName: "Date Creation",
      headerClassName: "super-app-theme--cell",

      width: 140,
    },
    {
      field: "modification",
      headerName: "Modifications",
      width: 160,
      renderCell: (params) => {
        return (
          <>
            <div className="flex items-center justify-center gap-4 mt-2 mr-8">
              <div>
                <RiAddCircleFill
                  className="collabListEdit"
                  onClick={() => openModal(params.row)}
                />
              </div>
              <div>
                <RiEdit2Line
                  className="collabListEdit"
                  onClick={() => openModalUpdImage(params.row)}
                />
              </div>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <Fragment>
      {isModalOpen && (
        <AffectedImageToJob closeModal={closeModal} rowJob={rowCategory} />
      )}{" "}
      {isModalOpenImage && (
        <UpdImageJob closeModal={closeModalUpdImage} rowJob={rowCategory} />
      )}{" "}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src={`${image}`} />
        </Box>
      </Modal>
      <div className="page__main">
        <h1>List Jobs:</h1>

        <Box
          sx={{
            height: "auto",
            width: "75vw",
            "& .super-app-theme--cell": {
              backgroundColor: "#fff",
              color: "#1a3e72",
              fontWeight: "bold",
            },
            boxShadow: 2,
            border: 2,
            borderRadius: 2,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
        >
          <DataGrid rows={jobs} columns={columns} getRowId={(row) => row.id} />
        </Box>
      </div>
    </Fragment>
  );
}

export default ListJobs;
